"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ClickAwayListener = _interopRequireDefault(require("@mui/material/ClickAwayListener"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var styles = {
  "expandedTouchArea": "yKCsHt",
  "fixedWidth": "Mf-Wtn",
  "visibleBox": "iUmWrK"
};
var getExpandedTouchAreaClassName = function getExpandedTouchAreaClassName(_ref) {
  var fixedWidth = _ref.fixedWidth;
  return (0, _clsx["default"])(styles.expandedTouchArea, fixedWidth && styles.fixedWidth);
};
var getExpandedTouchAreaStyle = function getExpandedTouchAreaStyle(_ref2) {
  var paddingTop = _ref2.paddingTop;
  return _objectSpread({}, paddingTop ? {
    '--padding-top': paddingTop
  } : {});
};
var DropdownContent = function DropdownContent(_ref3) {
  var children = _ref3.children,
    isOpen = _ref3.isOpen,
    openWithClick = _ref3.openWithClick,
    closeDropDown = _ref3.closeDropDown,
    onContentEnter = _ref3.onContentEnter,
    onContentLeave = _ref3.onContentLeave,
    onDropdownOpen = _ref3.onDropdownOpen,
    paddingTop = _ref3.paddingTop,
    fixedWidth = _ref3.fixedWidth,
    closeOnExpandedAreaClick = _ref3.closeOnExpandedAreaClick,
    isExternalOpen = _ref3.isExternalOpen;
  var touchAreaProps = openWithClick ? {} : {
    onMouseEnter: onContentEnter,
    onMouseLeave: onContentLeave
  };
  var handleListKeyDown = function handleListKeyDown(event) {
    if (['Tab', 'Escape', 'ArrowRight', 'ArrowLeft'].includes(event.key) && isOpen) {
      closeDropDown();
    }
  };
  (0, _react.useEffect)(function () {
    if (isOpen && typeof onDropdownOpen === 'function') {
      onDropdownOpen();
    }
    document.addEventListener('keydown', handleListKeyDown, true);
    return function () {
      return document.removeEventListener('keydown', handleListKeyDown, true);
    };
  }, []);
  var closeOnClick = function closeOnClick() {
    if (isOpen && (closeOnExpandedAreaClick || !isExternalOpen)) closeDropDown();
  };
  var closeOnKeyEnter = function closeOnKeyEnter(event) {
    if (event.key === 'Enter' && isOpen && closeOnExpandedAreaClick) closeDropDown();
  };

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
    onClickAway: closeDropDown
  }, /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: getExpandedTouchAreaClassName({
      fixedWidth: fixedWidth
    }),
    style: getExpandedTouchAreaStyle({
      paddingTop: paddingTop
    }),
    "data-dropdown-touch-area": true,
    onClick: closeOnClick,
    onKeyDown: closeOnKeyEnter
  }, touchAreaProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.visibleBox
  }, children)));
};
DropdownContent.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  closeDropDown: _propTypes["default"].func.isRequired,
  onContentEnter: _propTypes["default"].func.isRequired,
  onContentLeave: _propTypes["default"].func.isRequired,
  isOpen: _propTypes["default"].bool,
  openWithClick: _propTypes["default"].bool,
  onDropdownOpen: _propTypes["default"].func,
  paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  fixedWidth: _propTypes["default"].bool,
  closeOnExpandedAreaClick: _propTypes["default"].bool,
  isExternalOpen: _propTypes["default"].bool
} : {};
var _default = exports["default"] = DropdownContent;